export const HITO_SUBTIPOS = `
  query hitoSubtipos(
    $tenant_id: Int!,
    $skip: Int,
    $take: Int,
    $orderBy: HitoSubtipoOrderInput,
    $filter: FilterHitoSubtipoInput,
    $searchText: String
  ) {
    hitoSubtipos(
      tenant_id: $tenant_id,
      skip: $skip,
      take: $take,
      orderBy: $orderBy,
      filter: $filter,
      searchText: $searchText
    ) {
      __typename
      ... on HitoSubtipo {
        id
        hito_tipo_id
        name
        active
        vistage20_id
        its
        hito_tipo {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const HITO_SUBTIPO = `
  query hitoSubtipo($tenant_id: Int!, $id: Int!) {
    hitoSubtipo(tenant_id: $tenant_id, id: $id) {
      __typename
      ... on HitoSubtipo {
        id
        hito_tipo_id
        name
        active
        vistage20_id
        its
        hito_tipo {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
